import validate from "/app/node_modules/.pnpm/nuxt@3.17.1_@electric-sql+pglite@0.2.9_@parcel+watcher@2.4.1_@types+node@20.11.30_db0@0_38de638c43d2674c9138c340c50d5756/node_modules/nuxt/dist/pages/runtime/validate.js";
import authorization_45global from "/app/middleware/authorization.global.ts";
import sidebar_45global from "/app/middleware/sidebar.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.1_@electric-sql+pglite@0.2.9_@parcel+watcher@2.4.1_@types+node@20.11.30_db0@0_38de638c43d2674c9138c340c50d5756/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  authorization_45global,
  sidebar_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/node_modules/.pnpm/@sidebase+nuxt-auth@0.9.4_magicast@0.3.5_next-auth@4.21.1_next@13.5.6_@babel+core@7.26._b2d6bcfac01c12465fd38835e63853a7/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/auth.js")
}